import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "input", "editButton", "saveButton", "cancelButton"]
  static values = {
    userId: String,
    inloopId: String,
    persona: String
  }

  connect() {
    this.editing = false
    this.originalPersona = this.personaValue
  }

  edit(event) {
    event.preventDefault()
    this.editing = true
    this.inputTarget.value = this.personaValue
    this.showEditMode()
    this.inputTarget.focus()
    this.inputTarget.select()
  }

  cancel(event) {
    event.preventDefault()
    this.editing = false
    this.inputTarget.value = this.originalPersona
    this.personaValue = this.originalPersona
    this.showDisplayMode()
  }

  async save(event) {
    event.preventDefault()

    const newPersona = this.inputTarget.value.trim()

    if (!newPersona) {
      alert("Persona cannot be empty")
      return
    }

    // Disable buttons during save
    this.saveButtonTarget.disabled = true
    this.cancelButtonTarget.disabled = true

    try {
      const response = await fetch(
        `/facilitator/inloops/${this.inloopIdValue}/inloop_participants/${this.userIdValue}/update_persona`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
          },
          body: JSON.stringify({ persona: newPersona })
        }
      )

      const data = await response.json()

      if (data.success) {
        this.personaValue = newPersona
        this.originalPersona = newPersona
        this.displayTarget.textContent = newPersona
        this.editing = false
        this.showDisplayMode()
      } else {
        alert(`Error: ${data.error}`)
        this.saveButtonTarget.disabled = false
        this.cancelButtonTarget.disabled = false
      }
    } catch (error) {
      console.error("Failed to update persona:", error)
      alert("Failed to update persona. Please try again.")
      this.saveButtonTarget.disabled = false
      this.cancelButtonTarget.disabled = false
    }
  }

  handleKeydown(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      this.save(event)
    } else if (event.key === "Escape") {
      event.preventDefault()
      this.cancel(event)
    }
  }

  showEditMode() {
    this.displayTarget.classList.add("hidden")
    this.inputTarget.classList.remove("hidden")
    this.editButtonTarget.classList.add("hidden")
    this.saveButtonTarget.classList.remove("hidden")
    this.cancelButtonTarget.classList.remove("hidden")
  }

  showDisplayMode() {
    this.displayTarget.classList.remove("hidden")
    this.inputTarget.classList.add("hidden")
    this.editButtonTarget.classList.remove("hidden")
    this.saveButtonTarget.classList.add("hidden")
    this.cancelButtonTarget.classList.add("hidden")

    // Re-enable buttons
    this.saveButtonTarget.disabled = false
    this.cancelButtonTarget.disabled = false
  }
}
